import React, { useState, useEffect, useRef } from "react";

const YoutubeTrailer = ({ movieTitle, onVideoEnd, onNextClick }) => {
  const [trailerUrl, setTrailerUrl] = useState("");
  const [error, setError] = useState(null);
  const iframeRef = useRef(null);
  const playerRef = useRef(null);

  useEffect(() => {
    if (!movieTitle) {
      console.warn("⚠️ No movie title provided for YouTube search.");
      return;
    }

    console.log("🔍 Searching YouTube for:", `"${movieTitle} movie trailer"`);

    const apiKey = "AIzaSyD9vtpIk1CjyaW5UHSRP9obJTyDZWb25xg"; // Replace with your actual API key
    const searchQuery = `${movieTitle} movie trailer`;
    const url = `https://www.googleapis.com/youtube/v3/search?part=snippet&q=${encodeURIComponent(
      searchQuery
    )}&key=${apiKey}`;

    const fetchTrailer = async () => {
      try {
        const response = await fetch(url);
        const data = await response.json();

        console.log("📺 YouTube API Response:", data);

        if (data.items && data.items.length > 0) {
          setTrailerUrl(
            `https://www.youtube.com/embed/${data.items[0].id.videoId}?rel=0&modestbranding=1&enablejsapi=1`
          );
          console.log(
            "✅ Trailer found:",
            `https://www.youtube.com/embed/${data.items[0].id.videoId}`
          );
        } else {
          console.warn("⚠️ No trailer found for:", movieTitle);
          setError("No trailer found.");
        }
      } catch (error) {
        console.error("❌ Error fetching YouTube trailer:", error);
        setError("Failed to load trailer.");
      }
    };

    fetchTrailer();
  }, [movieTitle]);

  useEffect(() => {
    const loadYouTubeAPI = () => {
      if (!window.YT) {
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
    };

    loadYouTubeAPI();

    window.onYouTubeIframeAPIReady = () => {
      if (iframeRef.current) {
        playerRef.current = new window.YT.Player(iframeRef.current, {
          events: {
            onReady: (event) => {
              console.log("🎬 YouTube Player Ready");
              checkVideoTime(); // Start checking time
            },
          },
        });
      }
    };

    const checkVideoTime = () => {
      const interval = setInterval(() => {
        if (playerRef.current && playerRef.current.getDuration) {
          const duration = playerRef.current.getDuration();
          const currentTime = playerRef.current.getCurrentTime();

          if (duration > 0 && currentTime >= duration - 1) {
            // ✅ Detect 1 second before end
            console.log("✅ Video is ending soon, switching trailer...");
            clearInterval(interval); // Stop checking
            onVideoEnd(); // ✅ Auto-switch trailer
          }
        }
      }, 500); // Check every 0.5 seconds

      return () => clearInterval(interval);
    };
  }, [trailerUrl, onVideoEnd]);

  return (
    <div>
      {error ? (
        <p>{error}</p>
      ) : trailerUrl ? (
        <>
          <iframe
            ref={iframeRef}
            width="560"
            height="315"
            src={trailerUrl}
            title={movieTitle}
            allowFullScreen
          />
          <br />
          <button
            onClick={onNextClick}
            className="next-trailer-button centered-button"
          >
            Next Trailer
          </button>
        </>
      ) : (
        <p>Loading trailer...</p>
      )}
    </div>
  );
};

export default YoutubeTrailer;
